// 设计项目
export default [
  {
    path: '/customer',
    redirect: '/customer/project',
  },
  {
    path: '/customer/project',
    name: 'customer-project',
    component: () => import(/* webpackChunkName: "customer-project" */ '@/components/layout/MainView.vue'),
    meta: {
      title: '我的设计项目',
      url: process.env.VUE_APP_MICRO_BASE_URL,
      defaultPage: '#/customer/project',
      isMicroApp: true,
    },
    // meta: {title: '设计项目', url: 'https://unify.bds188.com/demo/index.html', isMicroApp: true},
  },
];
